export default __webpack_public_path__ + "static/media/creditos-fondo-cultura.ada50ade.jpg";